import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  const rankColors = ['text-accent-500', 'text-accent-500', 'text-accent-500'];

  const trendIcons: Record<string, string> = {
    up: 'ri-arrow-up-line text-primary-500',
    down: 'ri-arrow-down-line text-foreground-400',
    stable: 'ri-subtract-line text-foreground-400',
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            吃瓜热度排行
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            实时热度数据追踪，看看大家都在关注哪些劲爆话题
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 py-4 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-heading flex-shrink-0 ${
                idx < 3
                  ? 'bg-accent-100 ' + rankColors[idx]
                  : 'bg-background-100 text-foreground-400'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm text-foreground-800 truncate cursor-pointer hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  热度 {item.heat}
                </span>
                <span className={`flex items-center gap-0.5 text-xs whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-foreground-400' : 'text-foreground-400'
                }`}>
                  <i className={trendIcons[item.trend]}></i>
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}